module.exports = __webpack_public_path__ + "img/buses.6c0678fe.svg";